import { render } from "./AndroidCardFr.vue?vue&type=template&id=330a07bb&scoped=true"
import script from "./AndroidCardFr.vue?vue&type=script&lang=js"
export * from "./AndroidCardFr.vue?vue&type=script&lang=js"

import "./AndroidCardFr.vue?vue&type=style&index=0&id=330a07bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330a07bb"]])

export default __exports__